import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ebook-error-component-icon',
  imports: [NgbModule],
  templateUrl: './error-component-icon.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ErrorComponentIconComponent {}
